module.exports = __webpack_public_path__ + "img/icon_register.b31a786c.png";